import { render, staticRenderFns } from "./transfer-tool.vue?vue&type=template&id=5167ba60&scoped=true"
import script from "./transfer-tool.vue?vue&type=script&lang=js"
export * from "./transfer-tool.vue?vue&type=script&lang=js"
import style0 from "./transfer-tool.vue?vue&type=style&index=0&id=5167ba60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167ba60",
  null
  
)

export default component.exports